import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { validateProjectAsync } from 'src/redux/async/rfxManagement/rfpManagementAsync'

const initialState = {
  validateLoader: false,
  validateError: '',
  validation: '',
}

export const validateRFPProjectSlice = createSlice({
  name: 'validate-rfp-project',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(validateProjectAsync.pending), (state) => {
      state.validateLoader = true
    })
    builder.addMatcher(isAnyOf(validateProjectAsync.fulfilled), (state, action) => {
      state.validateLoader = false
      state.validation = action.payload
      state.validateError = ''
    })
    builder.addMatcher(isAnyOf(validateProjectAsync.rejected), (state, action) => {
      state.validateLoader = false
      state.validateError = action.payload
    })
  },
  reducers: {
    emptyValidationSlice: (state) => {
      state.validateLoader = false
      state.validateError = ''
      state.validation = []
    },
  },
})

export const { emptyValidationSlice } = validateRFPProjectSlice.actions

export default validateRFPProjectSlice.reducer
